import React, { useCallback } from 'react';
import { TypedMemo } from '../../../common/types';
import { Cover } from '../../../music24/components/primitives/Cover';
import { catalogArtworkSrc } from '../../catalog/catalogArtwork';
import { RecentCatalogRowProps } from './props';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the panel and its rows; the panel lives in its own file */
import styles from './RecentCatalogItems.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** One release out of the artist's catalog, as a single tap. */
const RecentCatalogRowComponent: React.FC<RecentCatalogRowProps> = ({ item, onPick }) => {
  const pick = useCallback(() => onPick(item), [item, onPick]);

  return (
    <button type="button" className={styles.row} onClick={pick}>
      <Cover src={catalogArtworkSrc(item, 34)} label={item.title} size={34} />
      <span className={styles.info}>
        <span className={styles.name}>{item.title}</span>
        <span className={styles.sub}>{item.artistName}</span>
      </span>
    </button>
  );
};

export const RecentCatalogRow = TypedMemo(RecentCatalogRowComponent);
